import { render } from "./MaterialPlayer.vue?vue&type=template&id=66d7dc5e&scoped=true"
import script from "./MaterialPlayer.vue?vue&type=script&lang=js"
export * from "./MaterialPlayer.vue?vue&type=script&lang=js"

import "./MaterialPlayer.vue?vue&type=style&index=0&id=66d7dc5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d7dc5e"]])

export default __exports__